import React, { useState, useEffect } from "react";
import { validate } from "../../../../utilities/formValidators";
import styled from "styled-components";
import classnames from "classnames";
import mask from "./Mask";
import Input from "../../../Form/Input";

export interface IInputProps {
    id: string;
    label?: string;
    name: string;
    value?: any;
    inputType: string;
    iconClassName?: string;
    containerClassName: string;
    inputClassName?: string;
    showCurrencyIcon?: boolean;
    onChange: (name: string, value: any) => void;
    disabled?: boolean;
    className?: string;
    required?: boolean;
    dataTestId?: string;
}

function getMaskValue(value) {
    const cleanValue = (value + "").replace(/\D+/g, "");
    return mask(cleanValue, 0, ".", ",", false, "$");
}

export default styled((props: IInputProps) => {

    const [displayValue, setDisplayValue] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        if (!props.disabled) {
            const { maskedValue } = getMaskValue(props.value || 0);
            setDisplayValue(maskedValue);
        } else {
            setDisplayValue("");
        }
    }, [props.value, props.disabled]);

    function handleInput(e: any) {
        setDisplayValue(e.target.value);
    }

    function handleBlur() {
        const { value } = getMaskValue(displayValue);
        if (props.value === value) {
            return;
        }

        if (validate(value, props.inputType)) {
            setError("");
            props.onChange(props.id, value);
        } else {
            props.onChange(props.id, 0);
            if (props.required) {
                setError("Please enter a dollar amount");
            }
        }
    }

    return (
        <Input
            className={classnames("form-group", props.className, props.containerClassName)}
            hasValue={(props.value + "").length > 0}
            error={error}
            id={props.id}
            label={props.label}>
            <input
                type="text"
                name={props.id}
                value={displayValue}
                disabled={props.disabled}
                onChange={handleInput}
                onBlur={handleBlur}
                className={classnames(
                    props.inputClassName,
                    "form-control",
                    "px-3",
                    {
                        "has-label": props.label,
                        disabled: props.disabled
                    }
                )}
                autoComplete="off"
                data-test-id={props.dataTestId}
            ></input>
        </Input>
    );
})`
    .form-control {
        height: 3.021rem;
        border: 1px solid #fff;;
    }

    .disabled {
        border: 1px solid #bdbdbd;
    }
`;